const taskStatus = {
    state: {
      taskTabsStatus: null, // 听评课任务页面tab状态
      selectExpertsList: [] // 选择专家后保存
    },
  
    mutations: {
      SET_TASK_TABS_STATUS: (state, data) => {
        state.taskTabsStatus = data;
      },
      SET_TASK_SELECT_EXPERTS_LIST: (state, data) => {
        state.selectExpertsList = data;
      }
    },
  
    actions: {
    }
  };
  
  export default taskStatus;